__turbopack_context__.v({
  "section": "styles-module__pJL5CW__section",
  "title": "styles-module__pJL5CW__title",
  "title--md": "styles-module__pJL5CW__title--md",
});
